import React, { useEffect, useRef, useState } from "react"
import { Heart, ShoppingCart, Wind, Share2, AtSign } from "lucide-react"

function FadeInSection({ children }) {
  const [isVisible, setVisible] = useState(false)
  const domRef = useRef()

  useEffect(() => {
    const currentRef = domRef.current // Guardar una referencia local
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => setVisible(entry.isIntersecting))
    })
    if (currentRef) observer.observe(currentRef)

    return () => {
      if (currentRef) observer.unobserve(currentRef)
    }
  }, []) // Dependencias vacías porque solo queremos que se configure una vez

  return (
    <div
      className={`transition-opacity duration-1000 ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
      ref={domRef}
    >
      {children}
    </div>
  )
}

export default function Support() {
  return (
    <>
      <style jsx global>{`
        @font-face {
          font-family: "Muar-Regular";
          src: url("/fonts/Muar-Regular.ttf") format("truetype");
          font-weight: normal;
          font-style: normal;
        }
        @font-face {
          font-family: "Muar-Stencil";
          src: url("/fonts/Muar-Stencil.ttf") format("truetype");
          font-weight: normal;
          font-style: normal;
        }
      `}</style>
      <div className="container mx-auto px-4 py-16 max-w-5xl">
        <FadeInSection>
          <h1 className="text-5xl mb-8 text-center text-purple-800 font-['Muar-Stencil']">
            Support My Work
          </h1>
        </FadeInSection>

        <FadeInSection>
          <div className="mb-12 flex justify-center">
            <div className="w-full max-w-3xl">
              <img
                src={`${process.env.PUBLIC_URL}/images/Cocacola.webp`}
                alt="Breatho with glasses"
                className="rounded-lg shadow-lg w-full h-auto"
              />
            </div>
          </div>
        </FadeInSection>

        <FadeInSection>
          <div className="bg-gradient-to-r from-purple-50 to-purple-100 p-10 rounded-2xl shadow-xl mb-16">
            <p className="text-xl leading-relaxed text-gray-700 italic font-['Muar-Regular']">
              Make a donation here, and help Luis Breatho's journey for true
              healing and creativity.
            </p>
          </div>
        </FadeInSection>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-16">
          <FadeInSection>
            <div className="bg-white p-10 rounded-2xl shadow-xl">
              <h2 className="text-3xl mb-8 text-purple-700 font-['Muar-Stencil']">
                Ways to Support
              </h2>
              <ul className="space-y-6">
                {[
                  { icon: ShoppingCart, text: "Purchase my artwork" },
                  { icon: Wind, text: "Attend a breathwork session" },
                  { icon: Share2, text: "Spread the word about my work" },
                  { icon: AtSign, text: "Follow me on social media" },
                ].map((item, index) => (
                  <li key={index} className="flex items-center">
                    <item.icon className="w-8 h-8 mr-4 text-purple-600" />
                    <span className="text-lg text-gray-700 font-['Muar-Regular']">
                      {item.text}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </FadeInSection>
          <FadeInSection>
            <div className="bg-white p-10 rounded-2xl shadow-xl">
              <h2 className="text-3xl mb-8 text-purple-700 font-['Muar-Stencil']">
                Donate
              </h2>
              <p className="text-lg text-gray-700 mb-8 font-['Muar-Regular']">
                If you'd like to make a direct contribution to support my work,
                your generosity will help fuel my creative endeavors and healing
                practices. Every donation, no matter the size, is deeply
                appreciated.
              </p>
              <a
                href="https://wa.me/+351965220370?text=Hello Luís, I would like to support your work."
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gradient-to-r from-purple-600 to-purple-800 hover:from-purple-700 hover:to-purple-900 text-white font-bold py-4 px-8 rounded-full transition duration-300 ease-in-out transform hover:scale-105 flex items-center justify-center text-xl"
              >
                <Heart className="w-6 h-6 mr-3" />
                Make a Donation
              </a>
            </div>
          </FadeInSection>
        </div>
      </div>
    </>
  )
}
